<template lang="pug">
  .component-reservation-smart-edit
    SearchVehicleAvailability(:selectable="false", :vehicle="item.vehicle")
    smart-edit(:options="options", :value="item", @input="updateFields")
    button.button.expanded(v-on:click="edit") Save and Submit
</template>
<script type="text/babel">
  import SmartEdit from "components/structure/SmartEdit"
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper";
  import SearchVehicleAvailability from "../SearchVehicleAvailability";

  export default {
    name: "ReservationSmartEdit",
    components: {SearchVehicleAvailability, SmartEdit},
    data() {
      return {
        options: {
          translations: {},
          types: {
            start: 'datetime',
            end: 'datetime',

          },
          disabled: [
            "id",
          ],
          list: [
            'start',
            'end',
          ],
          listMode: 'whitelist',
        }
      }
    },
    created() {
    },
    methods: {
      updateFields(item) {
        this.item = item
      },
      edit() {
        const request = {
          start: this.$convertTimestamp(this.item.start),
          end: this.$convertTimestamp(this.item.end),
        }

        KeplerBackofficeSdk.reservations.select(this.item).edit(request, () => {
          window.location.reload()
        })
      }
    },
    props: [
      'item'
    ]
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ReservationEdit.vue?5f5bd206